
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[target]/[product]",
      function () {
        return require("private-next-pages/[target]/[product].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[target]/[product]"])
      });
    }
  